import { __extends } from "tslib";
import PropTypes from 'prop-types';
import React from 'react';
import Spinner from 'spin.js';
var LoadingSpinner = /** @class */ (function (_super) {
    __extends(LoadingSpinner, _super);
    function LoadingSpinner(props) {
        var _this = _super.call(this, props) || this;
        _this.spinnerRef = React.createRef();
        return _this;
    }
    LoadingSpinner.prototype.componentDidMount = function () {
        var backgroundColour = this.props.backgroundColour;
        var rgb = parseInt(backgroundColour, 16); // convert rrggbb to decimal
        var luminance = getColourLuminance(rgb);
        var white = luminance < 0.5;
        var opts = {
            lines: 11,
            length: 8,
            width: 2,
            radius: 8,
            corners: 1,
            rotate: 0,
            direction: 1,
            color: white ? '#FFF' : '#000',
            speed: 1,
            trail: 60,
            shadow: false,
            hwaccel: false,
            className: 'spinner',
            zIndex: 2e9,
            top: '50%',
            left: '50%',
        };
        new Spinner(opts).spin(this.spinnerRef.current);
    };
    LoadingSpinner.prototype.render = function () {
        return React.createElement("div", { ref: this.spinnerRef });
    };
    LoadingSpinner.propTypes = {
        backgroundColour: PropTypes.string.isRequired,
    };
    return LoadingSpinner;
}(React.Component));
export default LoadingSpinner;
function getColourLuminance(rgb) {
    /* eslint-disable no-bitwise */
    var r = (rgb >> 16) & 0xff; // extract red
    var g = (rgb >> 8) & 0xff; // extract green
    var b = (rgb >> 0) & 0xff; // extract blue
    return 0.213 * (r / 255) + 0.715 * (g / 255) + 0.072 * (b / 255);
}
